var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"lock-screen-btn-con",attrs:{"icon":""},on:{"click":function($event){return _vm.lock()}}},on),[_c('v-icon',[_vm._v("lock")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.L('Bloquear Pantalla')))])])}
var staticRenderFns = []

export { render, staticRenderFns }